[
  {
    "id": "semi-truck-body-repair",
    "path": "/Semi-Truck-Body-Shop",
    "kind": "service",
    "navLabel": "Semi Truck Body Repair",
    "eyebrow": "Commercial truck bodywork",
    "title": "Semi Truck Body Repair in Brighton | Motor City Truck Collision",
    "description": "Cab, hood, bumper and paint repairs for semi tractors in Brighton, Michigan. Discuss collision damage, fleet colors and repair scope with Motor City.",
    "h1": "Semi Truck Body Repair",
    "intro": "Motor City Truck Collision repairs semi tractor cabs, hoods, bumpers, sleeper sides and body panels in Brighton, Michigan. From a damaged panel to a collision repair with refinishing, the work starts with the condition of your tractor and the parts affected.",
    "answer": {
      "question": "What does semi truck body repair include?",
      "text": "Semi truck body repair covers the cab, hood, bumper and related exterior panels, followed by paint preparation and refinishing where needed. If the impact may have affected the supporting structure, include that damage in the assessment rather than treating the job as paint alone."
    },
    "sections": [
      {
        "heading": "Match the repair to the damage",
        "paragraphs": [
          "A cracked hood, damaged cab corner and bent bumper need different repair plans. Wide photos show where the impact occurred; close photos help show the condition of individual panels, mounting areas and nearby trim.",
          "Tell the shop the tractor’s year, make and model, and identify any previous repairs or modifications. Photos begin the conversation; inspection determines what can be repaired and what needs replacement."
        ]
      },
      {
        "heading": "Bodywork and paint in one plan",
        "paragraphs": [
          "Include refinishing with the panel work from the start. A repaired area may need color matching and blending into adjacent surfaces, while a larger project may call for a broader repaint.",
          "For fleet equipment, supply the color code or company color standard when available. If you also need lettering or graphics, discuss that sequence after the body and paint scope is established."
        ]
      },
      {
        "heading": "Plan around the working unit",
        "paragraphs": [
          "Share the fleet number, insurance or purchase-order information, and your preferred return date. Scheduling depends on the damage, repair scope, parts and shop availability; the conversation should cover those details before you make an operating plan."
        ]
      }
    ],
    "checklist": {
      "heading": "What to send with your semi quote",
      "items": [
        "Year, make, model and fleet or unit number",
        "Wide views of the damaged side and close views of the affected panels",
        "Paint codes or fleet color information, if available",
        "Whether the unit rolls and any known transport needs",
        "Insurance or PO details and your preferred timing"
      ]
    },
    "faqs": [
      {
        "question": "Can you repair a semi tractor without a trailer?",
        "answer": "Yes. Semi bodywork can involve the tractor’s cab, hood, bumper and exterior panels without any trailer repair. Describe the tractor and the work you want quoted."
      },
      {
        "question": "Can I request painting without collision repairs?",
        "answer": "Yes. Commercial refinishing is a separate reason to request a quote. Include the surfaces to be painted, the current finish and any color requirements."
      },
      {
        "question": "Can photos give me a final repair price?",
        "answer": "Photos help identify the likely work and information still needed. Inspection, parts and the agreed repair scope determine the estimate; a photo alone cannot confirm hidden damage."
      }
    ],
    "related": [
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial truck painting"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body and frame repair"
      },
      {
        "path": "/Trailer-Repair",
        "label": "Trailer body repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Semi-Truck-Body-Shop",
      "https://www.motorcitytruckcollision.com/Fleet-Truck-Body-Repair",
      "https://www.motorcitytruckcollision.com/Commercial-Truck-Paint-Shop"
    ],
    "preservedFacts": [
      "Semi cab, hood, bumper and exterior bodywork",
      "Refinishing and supplied fleet colors",
      "Brighton shop location"
    ]
  },
  {
    "id": "box-truck-body-repair",
    "path": "/box-truck-repair.html",
    "kind": "service",
    "navLabel": "Box Truck Repair",
    "eyebrow": "Cargo bodies and commercial trucks",
    "title": "Box Truck Body Repair in Brighton | Motor City Truck Collision",
    "description": "Box truck collision, roof, wall, floor and door repairs in Brighton, Michigan. Send unit details and photos to discuss the cargo body work you need.",
    "h1": "Box Truck Body Repair",
    "intro": "Motor City Truck Collision repairs box truck bodies in Brighton, Michigan, including collision damage, roofs, walls, floors and doors. The cab and the cargo box are different parts of the job, so tell us which areas need attention.",
    "answer": {
      "question": "What parts of a box truck can be repaired?",
      "text": "Box truck bodywork can include roof openings, damaged sidewalls, floor and support damage, rear doors, and the body structure around the rear sill. Cab bodywork and painting can be included when needed. Engine and drivetrain concerns are a separate service question."
    },
    "sections": [
      {
        "heading": "Look beyond the visible panel",
        "paragraphs": [
          "A dock strike or collision may damage the outer skin and the supporting framework beneath it. A useful assessment considers the affected wall or roof, nearby framing, door openings and signs of water entry.",
          "Describe how the damage happened, the body manufacturer if known, and whether the cargo area is dry, insulated or refrigerated. Include the body style, such as cutaway, curtainside or dry-freight, and any damaged front cap, aerodynamic dome or cab-over attic. The chassis and cargo body may have different identifying information."
        ]
      },
      {
        "heading": "Repair the part your operation depends on",
        "paragraphs": [
          "Roof, sidewall, floor and rear-door problems affect different parts of the cargo body. A torn roof needs a different discussion from a damaged roll-up door or a soft section of floor.",
          "Use the focused pages below for those details. They explain what information helps the shop assess each area without turning every box-body problem into the same repair request."
        ]
      },
      {
        "heading": "Finish and fleet appearance",
        "paragraphs": [
          "Body repairs may also need paint, color matching or replacement graphics. Include your company color standard and the panels that carry lettering so the finish can be planned with the repair.",
          "For several units, identify each truck separately and explain your preferred sequence. Parts, condition and the agreed scope influence scheduling and cost."
        ]
      }
    ],
    "checklist": {
      "heading": "Useful box truck details",
      "items": [
        "Year, make, model, body length and body manufacturer if known",
        "Photos of the whole damaged side and the specific opening or impact",
        "Whether the problem involves the roof, wall, floor, door, cab or rear sill",
        "Details of insulation, interior lining or cargo tie-downs near the damage",
        "Fleet colors, unit number and your preferred return date"
      ]
    },
    "faqs": [
      {
        "question": "Can you repair the box without repainting the entire truck?",
        "answer": "The paint scope depends on the repaired material, existing finish and color match needed. Describe which areas you want repaired and refinished so the shop can discuss a suitable plan."
      },
      {
        "question": "What if the roof leak has damaged the floor?",
        "answer": "Include both problems in the request. Repairing the source of water entry and assessing the affected floor or supports are different parts of the same cargo-body project."
      },
      {
        "question": "Do rear-door problems count as box truck body repair?",
        "answer": "Yes. Roll-up door panels, tracks and the surrounding rear structure can be part of box-body repair. Identify the door type and show both sides of the opening in your photos."
      }
    ],
    "related": [
      {
        "path": "/Box-Truck-Roof-Repair-Cost",
        "label": "Roof repair and cost factors"
      },
      {
        "path": "/Box-Truck-Wall-Repair-Near-Me",
        "label": "Box truck wall repair"
      },
      {
        "path": "/Box-Truck-Roll-Up-Door-Repair-Near-Me",
        "label": "Roll-up door repair"
      },
      {
        "path": "/Isuzu-Freight-Box-Floor-Repair",
        "label": "Cargo floor repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/box-truck-repair.html",
      "https://www.motorcitytruckcollision.com/box-truck-roof-leak-body-repair",
      "https://www.motorcitytruckcollision.com/Box-Truck-Roll-Up-Door-Repair-Near-Me"
    ],
    "preservedFacts": [
      "Cargo roof/wall/floor/door repair",
      "Cab versus cargo body distinction",
      "Rear structure and refinishing scope"
    ]
  },
  {
    "id": "fleet-truck-body-repair",
    "path": "/Fleet-Truck-Body-Repair",
    "kind": "service",
    "navLabel": "Fleet Body Repair",
    "eyebrow": "For fleet managers",
    "title": "Fleet Truck Body & Frame Repair | Motor City Truck Collision",
    "description": "Fleet collision, bodywork, frame assessment and commercial paint in Brighton, Michigan. Discuss unit details, color standards and scheduling with the shop.",
    "h1": "Fleet Truck Body & Frame Repair",
    "intro": "Motor City Truck Collision handles bodywork and paint for fleet trucks in Brighton, Michigan. Box trucks, commercial cabs and service bodies can have different repair needs, but each unit needs a clear scope and an operating plan.",
    "answer": {
      "question": "Does fleet body repair include frame work?",
      "text": "Fleet collision work can include frame assessment, repair or straightening when the impact has affected the structure beneath the body. Rails, cross-members and rear sills should be considered alongside damaged panels, doors and liftgate pockets."
    },
    "sections": [
      {
        "heading": "One unit record for the whole repair",
        "paragraphs": [
          "Start with the fleet number and the vehicle’s year, make, model and body type. Identify damaged panels and any known structural concerns, then include the company color standard and graphics requirements.",
          "Insurance or purchase-order details help explain how you need the job discussed and authorized. Supplying those details does not replace inspection or the agreed repair scope."
        ]
      },
      {
        "heading": "Frame and body work belong in the same assessment",
        "paragraphs": [
          "Some impacts stay within the cargo box or outer panels; others affect rails, cross-members or the rear sill. The repair plan should account for that difference before the finish work is decided.",
          "When structural work is needed, discuss it with the panel repairs and check the related openings and interfaces. Photos of the damaged area and the opposite side help show the shop what needs closer assessment."
        ]
      },
      {
        "heading": "Talk through the scheduling constraints",
        "paragraphs": [
          "Explain which unit is down, whether several trucks need work, and the date you would prefer each back in service. Tell the shop if you would like to discuss staged arrivals.",
          "Timing depends on damage, parts, repair scope and the shop’s schedule. Confirm the plan with the shop before committing a unit’s return date to your routes."
        ]
      }
    ],
    "checklist": {
      "heading": "Fleet quote information",
      "items": [
        "Fleet number and a separate description for each unit",
        "Wide and close photos of body or rear-structure damage",
        "Known frame, door-opening or liftgate-pocket concerns",
        "Paint codes, company color standards and graphics information",
        "Insurance or PO information and preferred return dates"
      ]
    },
    "faqs": [
      {
        "question": "Can I discuss more than one damaged fleet truck?",
        "answer": "Yes. List each unit separately, identify the work needed and explain your preferred sequence. The shop can discuss the scope and scheduling details for the units involved."
      },
      {
        "question": "Is every box impact also frame damage?",
        "answer": "No. The cargo body and the vehicle frame are different structures. The assessment determines whether a job is confined to the body or also involves the supporting frame."
      },
      {
        "question": "Can fleet colors be included with collision repairs?",
        "answer": "Yes. Supply your color codes or company color standards with the request so refinishing is considered with the bodywork."
      }
    ],
    "related": [
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Fleet color matching and paint"
      },
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck bodywork"
      },
      {
        "path": "/Lift-Gate-Repair",
        "label": "Liftgate interface body repair"
      },
      {
        "path": "/how-to-spot-early-signs-of-structural-damage-on-commercial-trucks",
        "label": "Signs of structural damage"
      },
      {
        "path": "/how-cross-members-get-damaged-in-truck-collisions",
        "label": "Cross-member damage after a collision"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Fleet-Truck-Body-Repair",
      "https://www.motorcitytruckcollision.com/Commercial-Truck-Paint-Shop"
    ],
    "preservedFacts": [
      "Frame repair/straightening integrated with fleet bodywork",
      "Rails/cross-members/rear sills",
      "Unit IDs, fleet colors, insurance/PO details, staged scheduling discussion"
    ]
  },
  {
    "id": "commercial-truck-painting",
    "path": "/Commercial-Truck-Paint-Shop",
    "kind": "service",
    "navLabel": "Commercial Truck Painting",
    "eyebrow": "Painting and refinishing",
    "title": "Commercial Truck Painting in Brighton | Motor City Truck Collision",
    "description": "Commercial truck refinishing, panel blends and fleet color matching in Brighton, Michigan. Request painting on its own or with collision bodywork.",
    "h1": "Commercial Truck Painting",
    "intro": "A truck does not have to be collision damaged to need paint. Motor City Truck Collision provides commercial refinishing in Brighton, Michigan, for semi cabs, box trucks, fleet vehicles and RV bodywork.",
    "answer": {
      "question": "Can I request a quote for painting only?",
      "text": "Yes. Tell the shop which surfaces you want painted, the condition of the existing finish and the color or fleet standard you want matched. A panel blend, full cab repaint and broader vehicle refinish have different preparation and coverage requirements."
    },
    "sections": [
      {
        "heading": "Define the surfaces and the finish",
        "paragraphs": [
          "A single repaired panel is different from a complete cab or a large cargo body. Include the areas to be painted and any peeling finish, corrosion or body damage you already know about.",
          "If you want a color change or a fleet match, supply the color code or company standard when available. Discuss any lettering or graphics that will need removal or replacement."
        ]
      },
      {
        "heading": "Preparation is part of the paint work",
        "paragraphs": [
          "Refinishing includes more than choosing a color. The condition and material of the surface affect the preparation, primer and coating plan.",
          "When body repairs are also required, include them in the request from the beginning. The shop can discuss the repaired surfaces, adjacent color blends and the finish scope together."
        ]
      },
      {
        "heading": "Coordinate graphics after refinishing",
        "paragraphs": [
          "New paint and replacement graphics should be planned in the right order. Discuss the coating and its readiness for vinyl application with the shop rather than assuming the graphics can be applied immediately.",
          "Share your preferred timing, but confirm the schedule after the preparation and finish requirements are understood. There is no single turnaround or paint quantity that fits every truck."
        ]
      }
    ],
    "checklist": {
      "heading": "What helps a painting quote",
      "items": [
        "Vehicle type and the panels or body areas to be painted",
        "Current color and any supplied paint code or fleet standard",
        "Photos of the existing finish, if available",
        "Known peeling paint, rust, dents or previous repairs",
        "Lettering or graphics requirements and preferred timing"
      ]
    },
    "faqs": [
      {
        "question": "How much does it cost to paint a semi truck?",
        "answer": "The price depends on the area being painted, surface condition, preparation, color matching and the finish scope. Send the vehicle details and areas you want refinished for a job-specific discussion."
      },
      {
        "question": "Can a repaired panel match the rest of a fleet vehicle?",
        "answer": "Color matching and blending can be included in the refinishing discussion. Provide the paint code or fleet standard and photos of the existing finish when available."
      },
      {
        "question": "Do I need to buy the paint before requesting a quote?",
        "answer": "No. Describe the color and finish you want. The shop determines the coating plan and materials for the surfaces and work agreed."
      }
    ],
    "related": [
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body and paint work"
      },
      {
        "path": "/CommercialVehicleGraphicWraps.html",
        "label": "Commercial graphics and wraps"
      },
      {
        "path": "/earthmoving-equipment-restoration-paint-repair.html",
        "label": "Equipment painting and restoration"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Commercial-Truck-Paint-Shop",
      "https://www.motorcitytruckcollision.com/CommercialVehicleGraphicWraps.html"
    ],
    "preservedFacts": [
      "Paint-only inquiries",
      "Booth refinishing, panel blend/full-cab distinction, fleet color match",
      "Body/paint/graphics sequence without fixed cure promise"
    ]
  },
  {
    "id": "trailer-body-repair",
    "path": "/Trailer-Repair",
    "kind": "service",
    "navLabel": "Trailer Body Repair",
    "eyebrow": "Trailer collision and bodywork",
    "title": "Trailer Body Repair in Brighton | Motor City Truck Collision",
    "description": "Trailer skin, wall, roof, door and paint repairs in Brighton, Michigan. Discuss collision damage and related body structure with Motor City Truck Collision.",
    "h1": "Trailer Body & Collision Repair",
    "intro": "Motor City Truck Collision repairs trailer exteriors and body damage in Brighton, Michigan. The work can include skin, walls, roofs, doors, paint and the related body structure affected by an impact.",
    "answer": {
      "question": "How is trailer body repair different from mechanical repair?",
      "text": "Trailer body repair concerns the exterior panels, roof, doors, surrounding structure and finish. Axles, brakes, wheel ends and other towing or running-gear issues are mechanical work. Describe both kinds of damage so your inquiry reaches the right service."
    },
    "sections": [
      {
        "heading": "Describe the trailer and the impact",
        "paragraphs": [
          "Commercial, cargo and enclosed trailers have different body constructions. Identify the trailer type, manufacturer and size if known, then show the impact area and the surrounding structure.",
          "Rear-door and sill damage can extend beyond the visible skin. Include both sides of the opening, the roof or floor near the impact, and any signs of water entry."
        ]
      },
      {
        "heading": "Plan the body repair and the finish together",
        "paragraphs": [
          "A patch, replacement panel or larger section repair may also require paint, weather sealing or replacement graphics. Tell the shop what finish and appearance you want after the bodywork.",
          "For fleet trailers, provide the unit number, color standard and insurance or purchase-order information. Inspection and the agreed scope determine the repair plan."
        ]
      },
      {
        "heading": "Get mechanical concerns to the right provider",
        "paragraphs": [
          "List any axle, brake, coupler or other running-gear concerns separately when you call so the shop can help direct each part of the inquiry.",
          "The existing Motor City Trailer Repair business is a separate destination for trailer mechanical inquiries. Confirm its current service availability directly."
        ]
      }
    ],
    "note": {
      "heading": "Trailer mechanical work",
      "text": "For axle, brake and other mechanical trailer-service inquiries, contact Motor City Trailer Repair to confirm the appropriate service.",
      "href": "https://www.motorcitytrailerrepair.com/",
      "linkLabel": "Visit Motor City Trailer Repair"
    },
    "checklist": {
      "heading": "Trailer quote details",
      "items": [
        "Trailer type, size, manufacturer and unit number if available",
        "Photos of the impact and surrounding roof, walls or door opening",
        "Known leaks, floor damage or rear-sill concerns",
        "Paint or graphics requirements",
        "Any transport concerns and your preferred repair timing"
      ]
    },
    "faqs": [
      {
        "question": "Can an enclosed trailer’s sidewall and roof be repaired together?",
        "answer": "Yes, those areas can be discussed as one body-repair project. Show where the damage meets the roof, wall framework and nearby openings."
      },
      {
        "question": "Does this page cover trailer brakes or axle repairs?",
        "answer": "This page covers trailer bodywork and painting. Mechanical trailer-service inquiries should be directed to the appropriate provider, including Motor City Trailer Repair where available."
      },
      {
        "question": "Can the trailer be assessed from photos alone?",
        "answer": "Photos help describe the visible damage and begin a quote discussion. Inspection may be needed to determine the condition of the structure and the full repair scope."
      }
    ],
    "related": [
      {
        "path": "/Enclosed-Trailer-Repair",
        "label": "Enclosed trailer body repair"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial refinishing"
      },
      {
        "path": "/Top-Trailer-Maintenance-Services-That-Must-Be-Done-Regularly",
        "label": "Trailer maintenance guide"
      },
      {
        "path": "/how-to-inspect-a-trailer-tongue-after-impact",
        "label": "Trailer tongue assessment after an impact"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Trailer-Repair",
      "https://www.motorcitytruckcollision.com/Enclosed-Trailer-Repair"
    ],
    "preservedFacts": [
      "Trailer skin/wall/roof/door/paint",
      "Body structure and rear sill",
      "Mechanical work routed to sister business"
    ]
  },
  {
    "id": "rv-body-repair",
    "path": "/RV-Repair",
    "kind": "service",
    "navLabel": "RV Body & Roof Repair",
    "eyebrow": "Motorhome and RV exterior repair",
    "title": "RV Body & Roof Repair in Brighton | Motor City Truck Collision",
    "description": "RV exterior collision repair, fiberglass, roof damage and refinishing in Brighton, Michigan. Discuss the affected body areas and repair scope.",
    "h1": "RV Body & Roof Repair",
    "intro": "Motor City Truck Collision handles RV exterior bodywork in Brighton, Michigan. Fiberglass caps, sidewalls, roof openings and paint damage need an assessment that considers the affected materials and nearby seams.",
    "answer": {
      "question": "What RV work does the body shop handle?",
      "text": "The body-shop scope includes RV exterior collision damage, fiberglass and panel repairs, roof damage and refinishing. Appliances, plumbing, electrical systems and running gear are separate service questions; identify them when you contact the shop."
    },
    "sections": [
      {
        "heading": "Show the damage and the surrounding area",
        "paragraphs": [
          "A close photo of a crack is useful, but a wider view helps show where it sits on the RV. Include the full cap or sidewall, neighboring seams and any door or window opening near the damage.",
          "Tell the shop the RV’s year, manufacturer and model. Describe the impact or leak and any visible interior effects, without assuming that the outer crack is the only damage."
        ]
      },
      {
        "heading": "Body and roof problems can be connected",
        "paragraphs": [
          "Water entry after an impact can involve a roof opening, seam or damaged sidewall. Include those areas in the same assessment so the source of the water and the affected materials are discussed together.",
          "The condition behind the exterior surface may require inspection. Photos can start the repair conversation, but they cannot establish the full condition of the RV structure."
        ]
      },
      {
        "heading": "Plan paint and appearance with the repair",
        "paragraphs": [
          "RV finishes may include multiple colors, graphics or painted caps. Show the existing appearance and provide any paint or graphics information you have.",
          "Describe whether you want a localized repair, a larger refinishing project or exterior restoration. The agreed scope and materials determine the repair and scheduling discussion."
        ]
      }
    ],
    "checklist": {
      "heading": "RV quote information",
      "items": [
        "Year, manufacturer, model and approximate size",
        "Wide and close photos of exterior damage",
        "Photos of the nearby roof, seams, windows or doors",
        "Known water entry or interior effects",
        "Paint and graphics requirements and preferred timing"
      ]
    },
    "faqs": [
      {
        "question": "Can fiberglass cap damage be assessed for repair?",
        "answer": "Yes. Send wide and close photos of the cap and the areas around the damage. The shop can discuss an assessment and the body or refinishing work involved."
      },
      {
        "question": "Does roof damage always mean replacing the entire roof?",
        "answer": "The appropriate scope depends on the roof material, damaged area and underlying condition. An assessment is needed before choosing a localized repair or a broader replacement project."
      },
      {
        "question": "Do you repair RV appliances and interior systems?",
        "answer": "This page covers exterior body, roof and paint work. Ask the shop about the appropriate provider for appliance, plumbing, electrical or other mechanical concerns."
      }
    ],
    "related": [
      {
        "path": "/rv-body-roof-repair-guide",
        "label": "RV body and roof repair guide"
      },
      {
        "path": "/Complete-RV-Trailer-Repair-Maintenance",
        "label": "Planning RV trailer service"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial refinishing"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/RV-Repair",
      "https://www.motorcitytruckcollision.com/rv-body-roof-repair-guide"
    ],
    "preservedFacts": [
      "RV fiberglass/exterior/body/roof/paint",
      "Water intrusion after exterior damage",
      "Body versus interior-system scope"
    ]
  },
  {
    "id": "enclosed-trailer-repair",
    "path": "/Enclosed-Trailer-Repair",
    "kind": "service",
    "navLabel": "Enclosed Trailer Repair",
    "eyebrow": "Cargo trailer bodywork",
    "title": "Enclosed Trailer Body Repair | Motor City Truck Collision",
    "description": "Enclosed trailer walls, roofs, doors and collision bodywork in Brighton, Michigan. Share trailer details and photos to discuss the repair.",
    "h1": "Enclosed Trailer Body Repair",
    "intro": "Motor City Truck Collision repairs enclosed cargo trailer bodies in Brighton, Michigan. The project may involve exterior skin, walls, roof areas, door openings and the body structure around a collision or other damage.",
    "answer": {
      "question": "What does enclosed trailer body repair cover?",
      "text": "It covers the cargo enclosure: damaged exterior panels, roof and wall areas, doors and nearby body framework. The condition of the floor or rear sill should also be described when it is affected by the same impact."
    },
    "sections": [
      {
        "heading": "Identify the cargo body construction",
        "paragraphs": [
          "Tell the shop the trailer’s manufacturer, length and door arrangement if known. Photos should show the whole damaged side, the affected opening and the surrounding panel joints.",
          "An enclosed trailer may have different exterior skin, framework and interior lining materials. Include any insulation, interior panels or cargo fixtures close to the damage."
        ]
      },
      {
        "heading": "Include leaks and door-opening damage",
        "paragraphs": [
          "A damaged wall or roof may also create water entry. Show the area where water gets in and describe what you have noticed inside the trailer.",
          "If a rear or side door has been struck, include its opening and nearby body structure. Door hardware and the surrounding body may need separate assessment within the same project."
        ]
      },
      {
        "heading": "Discuss the finish and use of the trailer",
        "paragraphs": [
          "Paint, graphics and the intended cargo use influence the work you want quoted. Share company colors and identify lettering that will need to be considered after bodywork.",
          "Explain your preferred timing and any transport concerns. Axle, brake and other running-gear problems are mechanical inquiries rather than cargo-body repairs."
        ]
      }
    ],
    "checklist": {
      "heading": "Enclosed trailer details to send",
      "items": [
        "Manufacturer, size, unit number and door type",
        "Wide photos of the damaged roof or sidewall",
        "Close photos of openings, framework and panel joints",
        "Known leaks, lining damage or affected cargo fixtures",
        "Paint, graphics and scheduling requirements"
      ]
    },
    "faqs": [
      {
        "question": "Can wall and door damage be handled as one project?",
        "answer": "Yes. Describe both the wall damage and the door-opening or rear-structure concerns so the shop can assess the full bodywork scope."
      },
      {
        "question": "What if the trailer has insulation behind the damaged wall?",
        "answer": "Include that information and any photos showing the lining or insulation. The body construction affects the repair assessment and materials discussion."
      },
      {
        "question": "Where should I ask about brakes or axles?",
        "answer": "Those are mechanical trailer-service questions. Contact the appropriate provider, including the existing Motor City Trailer Repair business, to confirm availability."
      }
    ],
    "note": {
      "heading": "Mechanical trailer service",
      "text": "For axle, brake or running-gear inquiries, confirm service with Motor City Trailer Repair.",
      "href": "https://www.motorcitytrailerrepair.com/",
      "linkLabel": "Trailer mechanical service"
    },
    "related": [
      {
        "path": "/Trailer-Repair",
        "label": "Trailer body and collision repair"
      },
      {
        "path": "/Landscaping-Trailer-Repair-and-Maintenance",
        "label": "Landscaping trailer guide"
      },
      {
        "path": "/CommercialVehicleGraphicWraps.html",
        "label": "Trailer graphics and wraps"
      },
      {
        "path": "/why-enclosed-trailers-get-wall-bowing",
        "label": "Why trailer walls bow"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/Enclosed-Trailer-Repair",
      "https://www.motorcitytruckcollision.com/Trailer-Repair"
    ],
    "preservedFacts": [
      "Enclosed trailer skin, doors, roof and body structure",
      "Mechanical work distinguished from bodywork"
    ]
  },
  {
    "id": "commercial-vehicle-wraps",
    "path": "/CommercialVehicleGraphicWraps.html",
    "kind": "service",
    "navLabel": "Vehicle Graphics & Wraps",
    "eyebrow": "Company lettering and vinyl graphics",
    "title": "Commercial Vehicle Graphics & Wraps | Motor City Truck Collision",
    "description": "Commercial vehicle lettering and vinyl wraps in Brighton, Michigan. Discuss branding, coverage and body or paint preparation for your truck or trailer.",
    "h1": "Commercial Vehicle Graphics & Wraps",
    "intro": "Put your company’s identity on the vehicles people see at work. Motor City Truck Collision offers commercial lettering and vinyl graphics in Brighton, Michigan, from selected doors and panels to broader vehicle wraps.",
    "answer": {
      "question": "Can graphics be included after a body repair?",
      "text": "Yes. Body repairs and refinishing should be discussed before graphics are applied. The panels need to be in suitable condition, and new paint must be ready for vinyl application. Include the graphics with the overall project plan."
    },
    "sections": [
      {
        "heading": "Choose the coverage you actually need",
        "paragraphs": [
          "A company name on a pair of doors has a different scope from a full box-truck wrap. Identify the panels you want covered and the information the vehicle needs to communicate.",
          "Share your logo, brand colors and any artwork you already have. Explain whether you want to replace existing graphics, update a design or start with new vehicle lettering."
        ]
      },
      {
        "heading": "Plan the panel preparation first",
        "paragraphs": [
          "A wrap does not straighten a damaged panel. Dents, corrosion, peeling finishes and body repairs should be discussed before the graphic work is scheduled.",
          "If painting is part of the job, confirm the sequence and application timing with the shop. Readiness depends on the finish and project; a fixed waiting period does not fit every coating."
        ]
      },
      {
        "heading": "Keep a fleet’s appearance consistent",
        "paragraphs": [
          "For multiple vehicles, identify the body types and the locations of lettering or wraps on each. A tractor cab and a cargo box do not offer the same spaces for a design.",
          "Fleet colors, artwork files and unit information help establish the appearance you want. Ask the shop to discuss the design and installation scope for each vehicle."
        ]
      }
    ],
    "checklist": {
      "heading": "What helps a graphics quote",
      "items": [
        "Vehicle types and photos of the panels to be covered",
        "Logo, brand colors and available artwork files",
        "Full-wrap, partial-wrap or lettering preferences",
        "Condition of the existing paint and graphics",
        "Any bodywork or painting that needs to happen first"
      ]
    },
    "faqs": [
      {
        "question": "Do I need a full wrap to add my company name?",
        "answer": "No. Selected-panel graphics or lettering may fit the project. Describe the information and coverage you want so the shop can discuss the options."
      },
      {
        "question": "Can graphics hide dents or failed paint?",
        "answer": "Graphics are applied to the existing surface; they do not repair damaged bodywork. Include those conditions in the inquiry so preparation can be addressed first."
      },
      {
        "question": "Can existing graphics be considered during a collision repair?",
        "answer": "Yes. Show the graphics around the damaged area and provide any matching artwork or company standards you have. Their removal or replacement can be included in the project discussion."
      }
    ],
    "related": [
      {
        "path": "/motorcitygraphics.html",
        "label": "Planning graphics after bodywork"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial truck painting"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/CommercialVehicleGraphicWraps.html",
      "https://www.motorcitytruckcollision.com/motorcitygraphics.html"
    ],
    "preservedFacts": [
      "Commercial graphic design and application",
      "Full versus selected-panel wraps/lettering",
      "Body and paint before graphics; no ROI or cure promises"
    ]
  },
  {
    "id": "motor-city-graphics",
    "path": "/motorcitygraphics.html",
    "kind": "service",
    "navLabel": "Graphics After Bodywork",
    "eyebrow": "Finish the vehicle’s identity",
    "title": "Truck Graphics After Bodywork | Motor City Truck Collision",
    "description": "Plan truck lettering and graphics after bodywork or painting in Brighton, Michigan. Share artwork, company colors and the panels you want covered.",
    "h1": "Truck Graphics After Bodywork",
    "intro": "A repaired truck may also need its company name, colors or graphics restored. This page helps you plan that part of the project with Motor City Truck Collision’s Brighton shop, after the body and paint work are understood.",
    "answer": {
      "question": "When should lettering and wraps be planned?",
      "text": "Discuss the graphics when you discuss the bodywork, but apply them after the repaired surfaces and coatings are ready. Early planning helps identify artwork, panel coverage and replacement graphics without rushing the application stage."
    },
    "sections": [
      {
        "heading": "Identify what needs to be matched",
        "paragraphs": [
          "Photograph the lettering and graphics before repair when possible. Include a wider view showing their position on the vehicle and close views of logos, text and color details.",
          "If the company has artwork files or a brand standard, share those with the inquiry. Existing graphics and the repaired panels may need different preparation or replacement decisions."
        ]
      },
      {
        "heading": "Separate the body, paint and graphics stages",
        "paragraphs": [
          "A straight, suitably finished surface is the starting point for vinyl graphics. A graphic over a dented or peeling panel does not correct the underlying problem.",
          "Ask the shop to discuss the coating and application sequence. New paint readiness is a project-specific question, rather than a universal date promised in advance."
        ]
      },
      {
        "heading": "Think about the rest of the fleet",
        "paragraphs": [
          "Tell the shop whether the repaired unit should match other trucks, a new company design or a revised color scheme. Identify the body types involved and the panels to receive lettering.",
          "For wider coverage or a new wrap design, use the commercial graphics and wraps page. The scope can range from individual door lettering to larger vehicle graphics."
        ]
      }
    ],
    "checklist": {
      "heading": "Graphics planning information",
      "items": [
        "Photos showing the existing graphics and their placement",
        "Artwork files or company brand standards, if available",
        "Which repaired or repainted panels need graphics",
        "Whether the design is being matched or changed",
        "Fleet-unit details and preferred timing"
      ]
    },
    "faqs": [
      {
        "question": "Can a repaired box truck receive new graphics?",
        "answer": "Yes. Discuss the repaired skin and finish readiness first, then the design and coverage you want applied."
      },
      {
        "question": "What if I do not have the original artwork?",
        "answer": "Tell the shop what files and references you do have. Photos of the existing design can help begin the discussion about recreating or replacing the graphics."
      },
      {
        "question": "Should I choose a new design before the repair?",
        "answer": "Discuss the design early so the panel and paint plan accounts for it. Installation follows the surface preparation and coating requirements."
      }
    ],
    "related": [
      {
        "path": "/CommercialVehicleGraphicWraps.html",
        "label": "Graphics and wrap options"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Painting and refinishing"
      },
      {
        "path": "/box-truck-repair.html",
        "label": "Box truck body repair"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/motorcitygraphics.html",
      "https://www.motorcitytruckcollision.com/CommercialVehicleGraphicWraps.html"
    ],
    "preservedFacts": [
      "Motor City graphics URL retained",
      "Post-bodywork and paint sequence",
      "Company branding and full versus door-only scope"
    ]
  },
  {
    "id": "dustless-sandblasting",
    "path": "/dustless-sandblasting.html",
    "kind": "service",
    "navLabel": "Dustless Sandblasting",
    "eyebrow": "Surface preparation",
    "title": "Dustless Sandblasting in Brighton | Motor City Truck Collision",
    "description": "Discuss coating and rust removal for trucks, equipment and metal projects in Brighton, Michigan. Ask about preparation, priming and finish requirements.",
    "h1": "Dustless Sandblasting",
    "intro": "Surface preparation can be an important part of a truck or equipment refinishing project. Contact Motor City’s Brighton shop to discuss dustless blasting for coatings, rust and the surfaces you want prepared.",
    "answer": {
      "question": "What information is needed for a sandblasting quote?",
      "text": "Describe the item, its material and size, the coating or corrosion to be removed, and the finish you want afterward. Photos and access details help the shop discuss preparation, blasting, priming and painting as separate parts of the project."
    },
    "sections": [
      {
        "heading": "Start with the surface and the desired result",
        "paragraphs": [
          "A small metal part and a large piece of equipment require different preparation and handling. Tell the shop what the item is made from and whether existing paint, rust or other coatings need removal.",
          "Identify surfaces or components you want protected and describe any disassembly already planned. The suitable process and scope need to be discussed for the actual project, rather than assumed from the word sandblasting."
        ]
      },
      {
        "heading": "Plan what happens after coating removal",
        "paragraphs": [
          "If the project needs primer or a finish coat, include that in the initial inquiry. Surface preparation, epoxy priming and painting can be discussed as part of the finishing plan.",
          "A blasting quote and a complete refinish quote may cover different work. Ask which preparation, handling and finishing stages are included in the scope agreed with the shop."
        ]
      },
      {
        "heading": "Shop work and mobile inquiries",
        "paragraphs": [
          "The industrial-machinery service includes shop and qualifying mobile-project inquiries. Mobile work requires advance scheduling and suitable site conditions.",
          "For work at your location, provide the address, access information and project details. Confirm suitability and availability directly; mobile service is not a promise that every item or site can be accommodated."
        ]
      }
    ],
    "checklist": {
      "heading": "Details for a blasting inquiry",
      "items": [
        "Item type, material and approximate dimensions",
        "Photos of coatings, rust and the whole project",
        "Disassembly, handling and access information",
        "Whether you need primer or painting afterward",
        "Shop-delivery or mobile-site requirements and preferred timing"
      ]
    },
    "faqs": [
      {
        "question": "How is the right preparation method chosen?",
        "answer": "The surface material, condition, attached components and desired finish affect the preparation method. Describe those details so the shop can discuss a suitable approach for the actual project."
      },
      {
        "question": "Can primer and painting follow blasting?",
        "answer": "Those stages can be discussed with the shop as part of the project. Specify the finish you want so the quote scope includes the appropriate preparation and finishing requirements."
      },
      {
        "question": "What determines sandblasting cost?",
        "answer": "Size, material, existing coatings, corrosion, access, handling and the finish required influence the scope. Mobile setup and travel are additional factors for work at your site."
      }
    ],
    "related": [
      {
        "path": "/sandblasting-industrial-machinery.html",
        "label": "Industrial machinery and mobile blasting"
      },
      {
        "path": "/how-much-does-it-cost-to-sandblast.html",
        "label": "Sandblasting cost factors"
      },
      {
        "path": "/earthmoving-equipment-restoration-paint-repair.html",
        "label": "Equipment refinishing"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/dustless-sandblasting.html",
      "https://www.motorcitytruckcollision.com/sandblasting-industrial-machinery.html",
      "https://www.motorcitytruckcollision.com/how-much-does-it-cost-to-sandblast.html"
    ],
    "preservedFacts": [
      "Coating and corrosion removal",
      "Project-dependent scope; no universal safety/no-warp claim",
      "Shop/mobile qualification and finishing discussion"
    ]
  },
  {
    "id": "industrial-machinery-sandblasting",
    "path": "/sandblasting-industrial-machinery.html",
    "kind": "service",
    "navLabel": "Industrial Machinery Blasting",
    "eyebrow": "Machinery preparation and finishing",
    "title": "Industrial Machinery Sandblasting | Motor City Truck Collision",
    "description": "Shop and qualifying mobile machinery-blasting inquiries in Brighton, Michigan. Discuss coatings, access, preparation, epoxy primer and painting.",
    "h1": "Industrial Machinery Sandblasting",
    "intro": "Motor City’s sandblasting service in Brighton prepares industrial machinery surfaces for refinishing. Discuss the machine, the coating or corrosion involved, and whether the project needs blasting alone or a wider finishing plan.",
    "answer": {
      "question": "Is mobile industrial sandblasting available?",
      "text": "The service accepts inquiries for shop work and qualifying mobile projects. Mobile work must be scheduled in advance and meet site and project requirements. Contact the shop with the location, access and machinery details to confirm suitability and availability."
    },
    "sections": [
      {
        "heading": "Describe the machine before choosing the process",
        "paragraphs": [
          "Machinery, tooling and small parts do not all need the same handling or preparation. Identify the material, approximate dimensions, existing coatings and the areas to be cleaned.",
          "Explain which components will remain attached and what disassembly you have planned. Discuss components, openings and surfaces that must be considered during preparation rather than assuming the entire machine can be treated alike."
        ]
      },
      {
        "heading": "Choose blasting alone or a finishing project",
        "paragraphs": [
          "Epoxy priming and industrial painting can follow blasting as part of a finishing project. Tell the shop whether you want a prepared surface, primer, or a complete coating project.",
          "Make the requested finish part of the scope from the start. Preparation, handling, disassembly and reassembly requirements may affect what the shop needs to assess and quote."
        ]
      },
      {
        "heading": "Compare bringing the project in with mobile work",
        "paragraphs": [
          "For shop work, discuss delivery, dimensions and handling. For mobile work, describe the site location and access, along with the project’s size and surroundings.",
          "Mobile setup and travel affect the quote. Confirm qualifying conditions and the schedule before planning on-site work; the service is not suitable for every machine or location by default."
        ]
      }
    ],
    "checklist": {
      "heading": "Machinery project information",
      "items": [
        "Machine or part type, material and dimensions",
        "Photos of the machine and the coatings or corrosion",
        "Location, delivery or mobile access requirements",
        "Disassembly and protected-component information",
        "Desired primer, topcoat and scheduling requirements"
      ]
    },
    "faqs": [
      {
        "question": "Can small parts be discussed as well as large machinery?",
        "answer": "Yes. Describe the parts, material, coating and quantity. The shop can discuss their preparation and finishing scope separately from a large-machine project."
      },
      {
        "question": "Does blasting include epoxy primer and paint automatically?",
        "answer": "No. Specify the finishing stages you want. Blasting, priming and topcoat work should be clear in the project scope you discuss with the shop."
      },
      {
        "question": "Can every machine be safely blasted without preparation?",
        "answer": "No. Material, condition, attached components and the desired result all matter. Discuss the preparation and suitable process for the actual machine before arranging the work."
      }
    ],
    "related": [
      {
        "path": "/dustless-sandblasting.html",
        "label": "Dustless blasting overview"
      },
      {
        "path": "/how-much-does-it-cost-to-sandblast.html",
        "label": "Blasting cost factors"
      },
      {
        "path": "/earthmoving-equipment-restoration-paint-repair.html",
        "label": "Equipment paint and restoration"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/sandblasting-industrial-machinery.html",
      "https://www.motorcitytruckcollision.com/dustless-sandblasting.html"
    ],
    "preservedFacts": [
      "Shop and qualifying advance-scheduled mobile work",
      "Machinery/tooling/small parts",
      "Epoxy primer and painting discussed as separate scope"
    ]
  },
  {
    "id": "equipment-paint-restoration",
    "path": "/earthmoving-equipment-restoration-paint-repair.html",
    "kind": "service",
    "navLabel": "Equipment Paint & Restoration",
    "eyebrow": "Construction and working equipment",
    "title": "Equipment Painting & Restoration | Motor City Truck Collision",
    "description": "Equipment bodywork, preparation and repainting in Brighton, Michigan. Discuss construction equipment, company colors, logos and restoration scope.",
    "h1": "Equipment Painting & Restoration",
    "intro": "Working equipment can need body repair, coating removal or a new finish without being replaced. Motor City Truck Collision’s Brighton shop provides paint and exterior restoration for construction and earthmoving equipment.",
    "answer": {
      "question": "What should an equipment repaint quote include?",
      "text": "Include the equipment type, dimensions, surface condition and the finish you want. Describe body damage, corrosion, existing coatings, company colors and graphics. Preparation, bodywork and painting are separate parts of the restoration scope."
    },
    "sections": [
      {
        "heading": "Define the restoration you want",
        "paragraphs": [
          "A repaint and a broader exterior restoration are different projects. Identify damaged panels, rust, failed finishes and any areas you want repaired before painting.",
          "Equipment inquiries may involve loaders, excavators, skid steers, dozers or other working machines. Supply the make, model and dimensions so the shop can discuss the actual project and handling requirements."
        ]
      },
      {
        "heading": "Preparation comes before the finish",
        "paragraphs": [
          "Existing coatings, corrosion and exposed material affect the preparation and primer plan. Discuss which surfaces are to be stripped, repaired, masked or refinished.",
          "If blasting or other preparation is part of the project, include it with the paint inquiry. Ask which stages and components are included in the agreed scope rather than assuming a repaint includes a complete machine rebuild."
        ]
      },
      {
        "heading": "Use your company colors and identity",
        "paragraphs": [
          "Company colors, logos and graphics can be included with your equipment finish. Provide a color standard and artwork when available, and identify where you want the branding placed.",
          "Explain your preferred timing and how the equipment will reach the shop. Mechanical or operating-system work is a separate scope question that should be confirmed with the appropriate provider."
        ]
      }
    ],
    "checklist": {
      "heading": "Equipment details for the shop",
      "items": [
        "Equipment type, make, model and approximate dimensions",
        "Photos of body damage, corrosion and current coatings",
        "Panels and surfaces you want repaired or repainted",
        "Company color standards and logo or graphics files",
        "Delivery, handling and preferred timing information"
      ]
    },
    "faqs": [
      {
        "question": "Can I discuss repainting without a complete restoration?",
        "answer": "Yes. Identify the surfaces and finish you want. A paint project can be discussed separately from broader bodywork or exterior restoration."
      },
      {
        "question": "Can equipment be painted in company colors?",
        "answer": "Company colors and branding can be part of the inquiry. Supply the color standards and artwork so the finish and graphics scope can be discussed."
      },
      {
        "question": "What does exterior equipment restoration cover?",
        "answer": "It can include damaged body areas, surface preparation and the finish included in the project. Engine, hydraulic and other operating-system work are separate service questions."
      }
    ],
    "related": [
      {
        "path": "/sandblasting-industrial-machinery.html",
        "label": "Machinery blasting and preparation"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Commercial painting"
      },
      {
        "path": "/CommercialVehicleGraphicWraps.html",
        "label": "Company graphics and wraps"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/earthmoving-equipment-restoration-paint-repair.html",
      "https://www.motorcitytruckcollision.com/sandblasting-industrial-machinery.html"
    ],
    "preservedFacts": [
      "Construction equipment exterior/body/painting/restoration",
      "Company colors and logos",
      "Preparation, priming, refinishing"
    ]
  },
  {
    "id": "car-truck-detailing",
    "path": "/car-truck-detailing.html",
    "kind": "service",
    "navLabel": "Car & Truck Detailing",
    "eyebrow": "Interior and exterior cleaning",
    "title": "Car & Truck Detailing in Brighton | Motor City Truck Collision",
    "description": "Interior and exterior car and truck detailing inquiries in Brighton, Michigan. Discuss vehicle condition, cleaning priorities and scheduling.",
    "h1": "Car & Truck Detailing",
    "intro": "Motor City offers car and truck cleaning and detailing in Brighton, Michigan. Tell the shop what you would like cleaned and the condition of the vehicle so the detailing scope can be discussed.",
    "answer": {
      "question": "What should I include in a detailing request?",
      "text": "Describe the vehicle, the interior or exterior areas you want cleaned, and concerns such as dirt, spills, stains or pet hair. Photos can help show the condition, while the shop confirms the cleaning scope and scheduling."
    },
    "sections": [
      {
        "heading": "Focus on the areas that matter to you",
        "paragraphs": [
          "Daily use leaves different cleaning needs in different vehicles. Identify the seats, floors, trim, cargo areas or exterior surfaces you want considered.",
          "Tell the shop about spills, pet hair and visible stains, along with any materials or previous cleaning attempts that may affect the work. The requested scope should be more specific than simply asking for a clean vehicle."
        ]
      },
      {
        "heading": "Keep cleaning separate from repairs",
        "paragraphs": [
          "Detailing and body repair are different services. A cleaning project does not repair a dent, damaged panel, failed paint or structural corrosion.",
          "If you want both detailing and bodywork, explain each part when you call. The shop can discuss the relevant services and the sequence for the vehicle rather than treating cleaning as a replacement for repair."
        ]
      },
      {
        "heading": "Confirm the scope and schedule",
        "paragraphs": [
          "Ask what interior and exterior work is included for your vehicle. Condition, size and the areas being cleaned affect the discussion.",
          "Describe your preferred timing and confirm arrangements with the shop. Cleaning results depend on the materials and their condition; stain removal or a like-new outcome should not be assumed in advance."
        ]
      }
    ],
    "checklist": {
      "heading": "Detailing inquiry details",
      "items": [
        "Vehicle type and approximate size",
        "Interior, exterior or both",
        "Specific dirt, stain, spill or pet-hair concerns",
        "Photos of the areas to be discussed, if available",
        "Any separate bodywork needs and preferred timing"
      ]
    },
    "faqs": [
      {
        "question": "Can I ask about interior cleaning only?",
        "answer": "Yes. Identify the interior areas and concerns you want considered so the shop can discuss that scope rather than assuming you need exterior work too."
      },
      {
        "question": "Will detailing fix paint damage or rust?",
        "answer": "No. Damaged paint, dents and corrosion may need bodywork or refinishing. Describe those conditions separately from the cleaning request."
      },
      {
        "question": "Can every stain be removed?",
        "answer": "The material, age and condition of a stain affect the possible result. Discuss the affected area with the shop before assuming complete removal."
      }
    ],
    "related": [
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Painting and refinishing"
      },
      {
        "path": "/Rust-Prevention-How-You-Can-Slow-Down-Rust-On-Your-Vehicle",
        "label": "Corrosion and maintenance guide"
      },
      {
        "path": "/contact-motor-city-truck-collision.html",
        "label": "Contact the Brighton shop"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/car-truck-detailing.html"
    ],
    "preservedFacts": [
      "Interior and exterior car/truck cleaning",
      "Dirt, spills, stains and pet hair",
      "Scope and scheduling by shop; unrelated equipment promotion removed"
    ]
  },
  {
    "id": "horse-trailer-floor-lining",
    "path": "/RhinoLiningYourHorseTrailer.html",
    "kind": "service",
    "navLabel": "Horse Trailer Floor Lining",
    "eyebrow": "Floor condition before coating",
    "title": "Horse Trailer Floor Lining | Motor City Truck Collision",
    "description": "Discuss horse trailer floor condition, replacement needs and spray lining in Brighton, Michigan. A liner is not a repair for rotten flooring.",
    "h1": "Horse Trailer Floor Lining",
    "intro": "A horse trailer floor coating should be discussed only after the floor’s condition is understood. Motor City Truck Collision’s Brighton shop can help you discuss the difference between lining a sound floor and repairing damaged flooring.",
    "answer": {
      "question": "Can a spray liner repair a rotten trailer floor?",
      "text": "No. A liner is a coating over a suitable floor, not a structural replacement for soft or rotten wood. Floor damage and the source of water entry need assessment before a lining project is planned."
    },
    "sections": [
      {
        "heading": "Start with the floor, not the coating",
        "paragraphs": [
          "Tell the shop the floor material and what you have noticed: soft areas, damaged boards, retained moisture or visible wear. Photos can help describe the concern, but they do not establish the floor’s load-carrying condition.",
          "Discuss any repair or replacement needs before choosing a coating. Covering damaged material does not correct the underlying floor problem."
        ]
      },
      {
        "heading": "Consider where the moisture comes from",
        "paragraphs": [
          "A leaking roof or seam can continue to wet the floor after it is coated. Include known water-entry points and other trailer-body damage in the inquiry.",
          "The floor project and leak assessment may involve different parts of the trailer. Describe both so the work is planned around the cause as well as the affected surface."
        ]
      },
      {
        "heading": "Discuss the finish for a sound floor",
        "paragraphs": [
          "If the floor is suitable for coating, describe the surface you want and how the trailer is used. Ask the shop to confirm the lining product, preparation and coverage included in the quote.",
          "Describe the floor material, how the trailer is cleaned and any mats you use. Those details help the shop discuss a suitable product and preparation for the surface."
        ]
      }
    ],
    "checklist": {
      "heading": "Horse trailer floor details",
      "items": [
        "Trailer type and existing floor material",
        "Photos of visible wear, soft areas or damaged boards",
        "Known roof or seam leaks",
        "Any previous flooring or coating repairs",
        "The lining or replacement work you want assessed"
      ]
    },
    "faqs": [
      {
        "question": "Should damaged wood be lined or replaced?",
        "answer": "Damaged or soft flooring needs assessment for repair or replacement before a liner is considered. A coating cannot restore deteriorated structural material."
      },
      {
        "question": "Will a floor liner stop a roof leak?",
        "answer": "No. The source of the water entry needs to be addressed separately. Include roof or seam concerns when discussing the floor project."
      },
      {
        "question": "Does a photo prove that the floor is suitable for horses?",
        "answer": "No. Photos can describe visible conditions but cannot establish structural capacity or transport suitability. Arrange an appropriate assessment for those concerns."
      }
    ],
    "related": [
      {
        "path": "/Trailer-Repair",
        "label": "Trailer body and roof repairs"
      },
      {
        "path": "/Enclosed-Trailer-Repair",
        "label": "Cargo trailer bodywork"
      },
      {
        "path": "/Top-Trailer-Maintenance-Services-That-Must-Be-Done-Regularly",
        "label": "Trailer maintenance questions"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/RhinoLiningYourHorseTrailer.html"
    ],
    "preservedFacts": [
      "Liner over sound floor, not rotten wood repair",
      "Find water-entry source before lining",
      "No manufacturer authorization or structural safety promise"
    ]
  },
  {
    "id": "bodywork-approach",
    "path": "/A-Superior-Body-Shop",
    "kind": "about",
    "navLabel": "Our Bodywork Approach",
    "eyebrow": "Quality starts with a clear scope",
    "title": "Our Commercial Bodywork Approach | Motor City Truck Collision",
    "description": "Understand how to discuss truck, RV and fleet bodywork with Motor City Truck Collision in Brighton: damage assessment, preparation, paint and finish.",
    "h1": "Bodywork Planned Around Your Vehicle",
    "intro": "A working truck, cargo body, bus and RV exterior have different materials, openings and finish requirements. Motor City Truck Collision’s bodywork conversation starts with the vehicle, the damage and the result you need.",
    "answer": {
      "question": "What makes commercial bodywork different?",
      "text": "Commercial bodywork can involve large panels, cargo-box structure, service compartments and fleet finishes. The assessment needs to account for those details, including whether the damage affects only the exterior or the supporting structure as well."
    },
    "sections": [
      {
        "heading": "Understand the body before choosing the repair",
        "paragraphs": [
          "A damaged hood, box wall, roof opening and service-body compartment each need their own scope. Describe the impact, the affected areas and any known concerns behind the visible surface.",
          "Inspection may be needed to determine repair or replacement requirements. A clear panel list and the condition of nearby openings help keep the bodywork discussion specific to the vehicle."
        ]
      },
      {
        "heading": "Include preparation and finish",
        "paragraphs": [
          "Body repairs, corrosion preparation and refinishing are connected stages. Tell the shop the finish you want and provide any fleet color standards, paint codes or graphics information.",
          "A quality-focused plan should account for the surface material and condition before coating or graphics work begins. Discuss the preparation and finishing stages included in the project rather than relying on a broad promise of restoration."
        ]
      },
      {
        "heading": "Use the right service for each concern",
        "paragraphs": [
          "Motor City’s core pages explain truck, fleet, trailer and RV exterior work in more detail. The specialized pages cover cargo roofs, walls, floors, doors and service bodies.",
          "Engine, drivetrain, trailer running-gear and RV interior-system concerns should be identified separately. Confirm the appropriate provider for each part of the project when you contact the shop."
        ]
      }
    ],
    "checklist": {
      "heading": "Start a useful bodywork conversation",
      "items": [
        "Vehicle type, year, model and body manufacturer if known",
        "The damaged surfaces and any known structural or leak concerns",
        "Wide and close photos when available",
        "Desired paint, graphics or restoration result",
        "Unit information and your preferred timing"
      ]
    },
    "faqs": [
      {
        "question": "Can bodywork and painting be discussed together?",
        "answer": "Yes. Include the panel work and finish requirements in the same inquiry so the repair and refinishing scope can be considered together."
      },
      {
        "question": "Do commercial vehicle bodies all use the same repair materials?",
        "answer": "No. Cabs, cargo boxes, fiberglass RV panels and utility bodies can have different construction. Identify the vehicle and affected materials so the shop can discuss the actual project."
      },
      {
        "question": "What if my project involves more than exterior repairs?",
        "answer": "Explain the different concerns when you call. Bodywork, mechanical service and interior-system work may involve different providers and should not be assumed to be one service."
      }
    ],
    "related": [
      {
        "path": "/commercial-truck-body-repair-services",
        "label": "Browse truck bodywork services"
      },
      {
        "path": "/Fleet-Truck-Body-Repair",
        "label": "Fleet body and frame work"
      },
      {
        "path": "/Commercial-Truck-Paint-Shop",
        "label": "Paint preparation and refinishing"
      },
      {
        "path": "/about-motor-city-truck-collision",
        "label": "About the Brighton shop"
      }
    ],
    "sourceUrls": [
      "https://www.motorcitytruckcollision.com/A-Superior-Body-Shop",
      "https://www.motorcitytruckcollision.com/",
      "https://www.motorcitytruckcollision.com/Fleet-Truck-Body-Repair",
      "https://www.motorcitytruckcollision.com/RV-Repair",
      "https://www.motorcitytruckcollision.com/Trailer-Repair"
    ],
    "preservedFacts": [
      "Truck, bus/RV and commercial bodywork intent retained",
      "Specific body components and preparation/finish scope",
      "Unsupported exhaustive certifications/modification promises excluded"
    ]
  }
]
